// import React, { useState, useEffect } from "react";
// import {
//   IoCloseCircleOutline,
//   IoArrowBackCircleOutline,
// } from "react-icons/io5";
// import OtpVerification from "./OtpVerification";
// import axios from "axios";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useHistory } from "react-router-dom";
// import Login1 from "../auth/Login1";
// import { IoAlertCircleOutline } from "react-icons/io5";

// const SignUp1 = ({ onClose, isOpen, defaultMobile }) => {
//   const [userType, setUserType] = useState("Owner");
//   const [name, setName] = useState("");
//   const [mobile, setMobile] = useState(defaultMobile || "");
//   const [countryCode, setCountryCode] = useState("+91");
//   const [agreed, setAgreed] = useState(false);
//   const [showOtpModal, setShowOtpModal] = useState(false);
//   const [showLoginModal, setShowLoginModal] = useState(false);
//   const history = useHistory();
//   // Inside your component
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [errors, setErrors] = useState({
//     name: "",
//     mobile: "",
//   });

//   // Prevent background scrolling when modal is open
//   useEffect(() => {
//     if (showOtpModal || showLoginModal) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }

//     // Cleanup when component unmounts
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, [showOtpModal, showLoginModal]);

//   if (!isOpen) return null;

//   const handleSignUp = async () => {
//     let hasError = false;
//     const newErrors = { name: "", mobile: "" };

//     if (!name.trim()) {
//       newErrors.name = "Name is required";
//       hasError = true;
//     }

//     if (!mobile.trim()) {
//       newErrors.mobile = "Mobile number is required";
//       hasError = true;
//     } else if (mobile.trim().length < 10) {
//       newErrors.mobile = "Mobile number must be at least 10 digits";
//       hasError = true;
//     }

//     if (!agreed) {
//       toast.error("You must agree to terms & conditions");
//       return;
//     }

//     setErrors(newErrors);

//     if (hasError) return;

//     setIsSubmitting(true);
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/cust_api/generate-otp`,
//         {
//           mobile_number: mobile,
//           country_code: countryCode,
//         },
//       );

//       const data = response.data;

//       if (data.status === 1) {
//         toast.success("OTP sent successfully!");
//         setShowOtpModal(true);
//       } else {
//         toast.error(data.message || "Something went wrong.");
//       }
//     } catch (error) {
//       if (
//         error.response &&
//         error.response.data &&
//         error.response.data.message === "Mobile number already registered."
//       ) {
//         setErrors({
//           ...newErrors,
//           mobile: "Mobile number already registered.",
//         });
//       } else if (
//         error.response &&
//         error.response.data &&
//         error.response.data.message
//       ) {
//         toast.error(error.response.data.message);
//       } else {
//         toast.error("Error generating OTP. Please try again.");
//       }
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const goToPrivacyPolicy = () => {
//     history.push("/privacy-policy");
//     onClose();
//   };

//   const goToTermsAndConditions = () => {
//     history.push("/terms-conditions");
//     onClose();
//   };

//   return (
//     <>
//       {showOtpModal ? (
//         <OtpVerification
//           mobileNumber={mobile}
//           countryCode={countryCode}
//           fullName={name}
//           userType={userType}
//           onClose={onClose}
//           onSwitchToSignUp={() => setShowOtpModal(false)}
//         />
//       ) : showLoginModal ? (
//         <Login1 onClose={onClose} isOpen={true} defaultMobile={mobile} />
//       ) : (
//         <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black bg-opacity-50">
//           <div className="w-full max-w-sm p-4 bg-white shadow-lg rounded-2xl md:p-8">
//             <div className="flex items-center justify-between">
//               {/* Back Arrow */}
//               <button
//                 onClick={() => setShowLoginModal(true)}
//                 className="text-black hover:text-black"
//               >
//                 <IoArrowBackCircleOutline size={20} />
//               </button>

//               {/* Close Icon */}
//               <button onClick={onClose} className="text-black hover:text-black">
//                 <IoCloseCircleOutline size={20} />
//               </button>
//             </div>

//             <h2 className="mb-4 text-2xl font-semibold text-center text-gray-900">
//               Sign Up
//             </h2>

//             <label className="block mb-2 text-sm font-medium text-gray-700">
//               I am <span className="text-xl font-bold text-red-500">*</span>
//             </label>
//             <div className="flex mb-4 space-x-4">
//               {["Buyer/Owner", "Agent", "Builder"].map((type, index) => (
//                 <label
//                   key={index}
//                   className="flex items-center space-x-2 cursor-pointer"
//                 >
//                   <input
//                     type="radio"
//                     name="userType"
//                     value={type === "Buyer/Owner" ? "Owner" : type}
//                     checked={
//                       userType === (type === "Buyer/Owner" ? "Owner" : type)
//                     }
//                     onChange={() =>
//                       setUserType(type === "Buyer/Owner" ? "Owner" : type)
//                     }
//                     className="accent-rose-600"
//                   />
//                   <span className="text-gray-700">{type}</span>
//                 </label>
//               ))}
//             </div>

//             {/* Name */}
//             <label className="block mb-1 text-sm font-medium text-gray-700">
//               Name <span className="text-xl font-bold text-red-500">*</span>
//             </label>
//             <div className="mb-1">
//               <input
//                 type="text"
//                 placeholder="Name"
//                 value={name}
//                 onChange={(e) => {
//                   const input = e.target.value;
//                   const alphabetOnly = input.replace(/[^a-zA-Z\s]/g, "");
//                   setName(alphabetOnly);
//                   setErrors({ ...errors, name: "" });
//                 }}
//                 className={`w-full p-3 border rounded-lg text-gray-700 bg-white focus:outline-none ${
//                   errors.name ? "border-red-500" : "border-gray-300"
//                 }`}
//               />
//             </div>
//             {errors.name && (
//               <p className="flex items-center gap-1 mb-3 text-sm text-red-500">
//                 <IoAlertCircleOutline size={16} className="text-red-500" />
//                 {errors.name}
//               </p>
//             )}

//             {/* Mobile Number */}
//             <label className="block mb-1 text-sm font-medium text-gray-700">
//               Mobile Number{" "}
//               <span className="text-xl font-bold text-red-500">*</span>
//             </label>
//             <>
//               <div className="flex gap-2">
//                 <select
//                   className="w-1/3 p-3 text-gray-700 bg-white border border-gray-300 rounded-lg focus:outline-none"
//                   value={countryCode}
//                   onChange={(e) => setCountryCode(e.target.value)}
//                 >
//                   <option value="+91">IN +91</option>
//                   <option value="+1">US +1</option>
//                   <option value="+44">UK +44</option>
//                   <option value="+61">AU +61</option>
//                   <option value="+81">JP +81</option>
//                   <option value="+49">DE +49</option>
//                   <option value="+971">AE +971</option>
//                   <option value="+7">RU +7</option>
//                   <option value="+27">ZA +27</option>
//                 </select>

//                 <div className="w-2/3">
//                   <input
//                     type="text"
//                     placeholder="Mobile Number"
//                     value={mobile}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       if (/^\d{0,10}$/.test(value)) {
//                         setMobile(value);
//                         setErrors({ ...errors, mobile: "" });
//                       }
//                     }}
//                     className={`w-full p-3 border rounded-lg text-gray-700 bg-white focus:outline-none ${
//                       errors.mobile ? "border-red-500" : "border-gray-300"
//                     }`}
//                   />
//                 </div>
//               </div>
//               {errors.mobile && (
//                 <p className="flex items-center gap-1 mt-1 text-sm text-red-500">
//                   <IoAlertCircleOutline size={16} className="text-red-500" />
//                   {errors.mobile}
//                 </p>
//               )}
//             </>

//             <label className="flex items-center mb-4 space-x-2 text-sm text-gray-600 cursor-pointer">
//               <input
//                 type="checkbox"
//                 checked={agreed}
//                 onChange={() => setAgreed(!agreed)}
//                 className="accent-rose-600"
//               />
//               <span>
//                 <span className="mr-1 text-xl font-bold text-red-500">*</span>I
//                 agree to ZeroBriks{" "}
//                 <span
//                   onClick={goToTermsAndConditions}
//                   className="mr-2 font-medium my-text cursor-pointer hover:underline"
//                 >
//                   T&C
//                 </span>
//                 <span className="mr-2 font-medium text-gray-600 cursor-pointer ">
//                   and
//                 </span>
//                 <span
//                   onClick={goToPrivacyPolicy}
//                   className="font-medium my-text cursor-pointer hover:underline"
//                 >
//                   Privacy Policy
//                 </span>
//               </span>
//             </label>

//             <button
//               onClick={handleSignUp}
//               className={`w-full py-3 rounded-lg text-lg font-medium transition ${
//                 !agreed
//                   ? "bg-gray-400 text-white cursor-not-allowed"
//                   : "my-bg text-white hover:my-bg"
//               }`}
//               disabled={!agreed}
//             >
//               {isSubmitting ? "Sending OTP..." : "Sign Up"}
//             </button>

//             <p className="mt-4 text-sm text-center text-gray-500">
//               Already have an account?{" "}
//               <button
//                 onClick={() => setShowLoginModal(true)}
//                 className="font-semibold my-text hover:underline"
//               >
//                 Login
//               </button>
//             </p>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default SignUp1;import React, { useState, useEffect } from "react";



import {
  IoCloseCircleOutline,
  IoArrowBackCircleOutline,
  IoAlertCircleOutline,
  IoHomeOutline,
  IoKeyOutline,
  IoConstructOutline,
  IoPersonOutline,
  IoCallOutline,
  IoMailOutline,
  IoLocationOutline,
  IoShieldCheckmark,
  IoPeople,
  IoHardwareChipOutline,
  IoCashOutline,
  IoLockClosed,
  IoHeadset,
  IoArrowForward,
  IoCheckmark,
} from "react-icons/io5";
import OtpVerification from "./OtpVerification";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom";
import Login1 from "../auth/Login1";
import React, { useState, useEffect } from "react";
const MAROON = "#7a0f2e";
const GOLD = "#d4952b";

const USER_TYPES = [
  {
    label: "Buyer/Owner",
    value: "Owner",
    desc1: "Find or list your",
    desc2: "property",
    Icon: IoHomeOutline,
  },
  {
    label: "Agent",
    value: "Agent",
    desc1: "Connect clients with",
    desc2: "the right property",
    Icon: IoKeyOutline,
  },
  {
    label: "Builder",
    value: "Builder",
    desc1: "Promote your projects",
    desc2: "and reach more buyers",
    Icon: IoConstructOutline,
  },
];

const BENEFITS = [
  { Icon: IoShieldCheckmark, title: "Verified Properties", sub: "100% verified & genuine listings", color: MAROON },
  { Icon: IoPeople, title: "Verified Owners", sub: "Connect with trusted owners", color: GOLD },
  { Icon: IoHardwareChipOutline, title: "AI Property Search", sub: "Smart recommendations for you", color: MAROON },
  { Icon: IoCashOutline, title: "Zero Brokerage", sub: "No hidden charges", color: GOLD },
  { Icon: IoLockClosed, title: "Secure Transactions", sub: "Your data is 100% protected", color: MAROON },
  { Icon: IoHeadset, title: "Customer Support", sub: "We are always here to help", color: GOLD },
];

const CITIES = [
  "Bhopal",
  "Indore",
  "Jabalpur",
  "Mumbai",
  "Delhi",
  "Bengaluru",
  "Hyderabad",
  "Chennai",
  "Pune",
  "Kolkata",
  "Ahmedabad",
  "Nagpur",
];

const SignUp1 = ({ onClose, isOpen, defaultMobile }) => {
  const [userType, setUserType] = useState("Owner");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState(defaultMobile || "");
  const [countryCode, setCountryCode] = useState("+91");
  const [agreed, setAgreed] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const history = useHistory();
  // Inside your component
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    email: "",
    city: "",
  });
  // UI-only fields (shown in the new design, not used by the existing flow)
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");

  // Prevent background scrolling when modal is open
  useEffect(() => {
    if (showOtpModal || showLoginModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showOtpModal, showLoginModal]);

  if (!isOpen) return null;

  const handleSignUp = async () => {
    let hasError = false;
    const newErrors = { name: "", mobile: "", email: "", city: "" };

    const cleanName = name.trim().replace(/\s+/g, " ");
    if (!cleanName) {
      newErrors.name = "Name is required";
      hasError = true;
    } else if (cleanName.length < 2) {
      newErrors.name = "Name must be at least 2 letters";
      hasError = true;
    } else if (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(cleanName)) {
      newErrors.name = "Name can contain only letters";
      hasError = true;
    }

    if (!mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
      hasError = true;
    } else if (!/^\d{10}$/.test(mobile.trim())) {
      newErrors.mobile = "Mobile number must be exactly 10 digits";
      hasError = true;
    } else if (countryCode === "+91" && !/^[6-9]/.test(mobile.trim())) {
      newErrors.mobile = "Enter a valid mobile number (starts with 6-9)";
      hasError = true;
    }

    if (
      email.trim() &&
      !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/.test(
        email.trim(),
      )
    ) {
      newErrors.email = "Enter a valid email address";
      hasError = true;
    }

    if (!city) {
      newErrors.city = "Please select your city";
      hasError = true;
    }

    if (!agreed) {
      toast.error("You must agree to terms & conditions");
      return;
    }

    setErrors(newErrors);

    if (hasError) return;

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/cust_api/generate-otp`,
        {
          mobile_number: mobile,
          country_code: countryCode,
        },
      );

      const data = response.data;

      if (data.status === 1) {
        toast.success("OTP sent successfully!");
        setShowOtpModal(true);
      } else {
        toast.error(data.message || "Something went wrong.");
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message === "Mobile number already registered."
      ) {
        setErrors({
          ...newErrors,
          mobile: "Mobile number already registered.",
        });
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Error generating OTP. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const goToPrivacyPolicy = () => {
    history.push("/privacy-policy");
    onClose();
  };

  const goToTermsAndConditions = () => {
    history.push("/terms-conditions");
    onClose();
  };

  const inputBase =
    "w-full px-3 py-1.5 text-xs text-gray-700 bg-white border rounded-lg focus:outline-none focus:border-[#7a0f2e]";

  const IconBox = ({ children }) => (
    <div
      className="flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-xl"
      style={{ backgroundColor: "#fbeef0", color: MAROON }}
    >
      {children}
    </div>
  );

  return (
    <>
      {showOtpModal ? (
        <OtpVerification
          mobileNumber={mobile}
          countryCode={countryCode}
          fullName={name}
          userType={userType}
          onClose={onClose}
          onSwitchToSignUp={() => setShowOtpModal(false)}
        />
      ) : showLoginModal ? (
        <Login1 onClose={onClose} isOpen={true} defaultMobile={mobile} />
      ) : (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-2 bg-black bg-opacity-50">
          <div className="relative flex w-full max-w-2xl overflow-hidden bg-white shadow-2xl rounded-2xl">
            {/* ---------- Left info panel (desktop only) ---------- */}
            <div
              className="flex-col hidden w-5/12 p-4 md:flex"
              style={{ backgroundColor: "#fbf6f4" }}
            >
              <span
                className="self-start px-2.5 py-0.5 mb-2 text-[10px] font-medium rounded-full"
                style={{ backgroundColor: "#f6e1e5", color: MAROON }}
              >
                Step 1 of 2
              </span>

              <h2 className="text-xl font-bold leading-tight text-gray-900">
                Create Your
                <br />
                <span style={{ color: MAROON }}>Account</span>
              </h2>
              <div
                className="w-8 h-0.5 mt-1.5 mb-2 rounded"
                style={{ backgroundColor: GOLD }}
              />

              <p className="mb-1.5 text-sm font-semibold leading-snug text-gray-900">
                Join India&apos;s Trusted Real Estate Platform
              </p>
              <p className="mb-3 text-[11px] leading-relaxed text-gray-600">
                Create your free account to access verified properties, connect
                with verified owners, and experience AI-powered property search
                with zero brokerage.
              </p>

              <h3
                className="mb-1.5 text-xs font-bold"
                style={{ color: MAROON }}
              >
                Why Join ZeroBriks?
              </h3>

              <ul className="space-y-1">
                {BENEFITS.map(({ Icon, title, sub, color }) => (
                  <li key={title} className="flex items-center gap-2">
                    <span
                      className="flex items-center justify-center flex-shrink-0 w-5 h-5 text-white rounded-full"
                      style={{ backgroundColor: color }}
                    >
                      <Icon size={11} />
                    </span>
                    <div className="leading-tight">
                      <p className="text-[10px] font-semibold leading-tight text-gray-900">
                        {title}
                      </p>
                      <p className="text-[9px] leading-tight text-gray-500">
                        {sub}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {/* ---------- Right form panel ---------- */}
            <div className="flex-1 p-3 md:p-4">
              <div className="flex items-center justify-between mb-1">
                {/* Back Arrow */}
                <button
                  onClick={() => setShowLoginModal(true)}
                  className="text-black hover:text-black"
                >
                  <IoArrowBackCircleOutline size={18} />
                </button>

                {/* Close Icon */}
                <button
                  onClick={onClose}
                  className="text-black hover:text-black"
                >
                  <IoCloseCircleOutline size={18} />
                </button>
              </div>

              <h2 className="mb-2 text-xs font-semibold text-gray-900">
                Select Your Account Type{" "}
                <span className="sr-only">(required)</span>
              </h2>

              {/* Account type cards */}
              <div className="grid grid-cols-3 gap-1.5 mb-3">
                {USER_TYPES.map(({ label, value, desc1, desc2, Icon }) => {
                  const selected = userType === value;
                  return (
                    <label
                      key={value}
                      className="relative flex flex-col items-center px-2 py-2 text-center transition border-2 cursor-pointer rounded-xl"
                      style={{
                        borderColor: selected ? MAROON : "#e5e7eb",
                        backgroundColor: selected ? "#fbeef0" : "#ffffff",
                      }}
                    >
                      <input
                        type="radio"
                        name="userType"
                        value={value}
                        checked={selected}
                        onChange={() => setUserType(value)}
                        className="sr-only"
                      />
                      {selected && (
                        <span
                          className="absolute flex items-center justify-center w-5 h-5 text-white rounded-full top-2 right-2"
                          style={{ backgroundColor: MAROON }}
                        >
                          <IoCheckmark size={12} />
                        </span>
                      )}
                      <span
                        className="flex items-center justify-center w-8 h-8 mb-1 rounded-full"
                        style={{
                          backgroundColor: selected ? "#f6e1e5" : "#fdf3e3",
                          color: selected ? MAROON : GOLD,
                        }}
                      >
                        <Icon size={16} />
                      </span>
                      <span
                        className="text-[11px] font-semibold"
                        style={{ color: selected ? MAROON : GOLD }}
                      >
                        {label}
                      </span>
                      <span className="mt-0.5 text-[10px] leading-tight text-gray-500">
                        {desc1}
                        <br />
                        {desc2}
                      </span>
                    </label>
                  );
                })}
              </div>

              {/* Name */}
              <div className="flex items-start gap-2 mb-2">
                <IconBox>
                  <IoPersonOutline size={15} />
                </IconBox>
                <div className="flex-1">
                  <label className="block mb-0.5 text-[11px] font-semibold text-gray-800">
                    Full Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter your full name"
                    autoComplete="name"
                    maxLength={50}
                    value={name}
                    onChange={(e) => {
                      const input = e.target.value;
                      const alphabetOnly = input.replace(/[^a-zA-Z\s]/g, "");
                      setName(alphabetOnly);
                      setErrors({ ...errors, name: "" });
                    }}
                    className={`${inputBase} ${
                      errors.name ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.name && (
                    <p className="flex items-center gap-1 mt-0.5 text-xs text-red-500">
                      <IoAlertCircleOutline
                        size={16}
                        className="text-red-500"
                      />
                      {errors.name}
                    </p>
                  )}
                </div>
              </div>

              {/* Mobile Number */}
              <div className="flex items-start gap-2 mb-2">
                <IconBox>
                  <IoCallOutline size={15} />
                </IconBox>
                <div className="flex-1">
                  <label className="block mb-0.5 text-[11px] font-semibold text-gray-800">
                    Mobile Number <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-2">
                    <select
                      className="w-[32%] px-2 py-1.5 text-xs text-gray-700 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-[#7a0f2e]"
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                    >
                      <option value="+91">IN +91</option>
                      <option value="+1">US +1</option>
                      <option value="+44">UK +44</option>
                      <option value="+61">AU +61</option>
                      <option value="+81">JP +81</option>
                      <option value="+49">DE +49</option>
                      <option value="+971">AE +971</option>
                      <option value="+7">RU +7</option>
                      <option value="+27">ZA +27</option>
                    </select>

                    <div className="flex-1">
                      <input
                        type="tel"
                        inputMode="numeric"
                        autoComplete="tel-national"
                        maxLength={10}
                        placeholder="Enter 10-digit mobile number"
                        value={mobile}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,10}$/.test(value)) {
                            setMobile(value);
                            setErrors({ ...errors, mobile: "" });
                          }
                        }}
                        className={`${inputBase} ${
                          errors.mobile ? "border-red-500" : "border-gray-300"
                        }`}
                      />
                    </div>
                  </div>
                  {errors.mobile && (
                    <p className="flex items-center gap-1 mt-0.5 text-xs text-red-500">
                      <IoAlertCircleOutline
                        size={16}
                        className="text-red-500"
                      />
                      {errors.mobile}
                    </p>
                  )}
                </div>
              </div>

              {/* Email (optional, UI only) */}
              <div className="flex items-start gap-2 mb-2">
                <IconBox>
                  <IoMailOutline size={15} />
                </IconBox>
                <div className="flex-1">
                  <label className="block mb-0.5 text-[11px] font-semibold text-gray-800">
                    Email Address{" "}
                    <span className="font-normal text-gray-500">
                      (Optional)
                    </span>
                  </label>
                  <input
                    type="email"
                    inputMode="email"
                    autoComplete="email"
                    maxLength={100}
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value.replace(/\s/g, ""));
                      setErrors({ ...errors, email: "" });
                    }}
                    className={`${inputBase} ${
                      errors.email ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors.email && (
                    <p className="flex items-center gap-1 mt-0.5 text-xs text-red-500">
                      <IoAlertCircleOutline
                        size={16}
                        className="text-red-500"
                      />
                      {errors.email}
                    </p>
                  )}
                </div>
              </div>

              {/* City (UI only) */}
              <div className="flex items-start gap-2 mb-2">
                <IconBox>
                  <IoLocationOutline size={15} />
                </IconBox>
                <div className="flex-1">
                  <label className="block mb-0.5 text-[11px] font-semibold text-gray-800">
                    Select City <span className="text-red-500">*</span>
                  </label>
                  <select
                    value={city}
                    onChange={(e) => {
                      setCity(e.target.value);
                      setErrors({ ...errors, city: "" });
                    }}
                    className={`${inputBase} ${
                      errors.city ? "border-red-500" : "border-gray-300"
                    } ${city ? "" : "text-gray-400"}`}
                  >
                    <option value="">Select your city</option>
                    {CITIES.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                  {errors.city && (
                    <p className="flex items-center gap-1 mt-0.5 text-xs text-red-500">
                      <IoAlertCircleOutline
                        size={16}
                        className="text-red-500"
                      />
                      {errors.city}
                    </p>
                  )}
                </div>
              </div>

              {/* Terms */}
              <label className="flex items-center mb-2 space-x-2 text-[11px] text-gray-600 cursor-pointer">
                <input
                  type="checkbox"
                  checked={agreed}
                  onChange={() => setAgreed(!agreed)}
                  className="w-4 h-4"
                  style={{ accentColor: MAROON }}
                />
                <span>
                  I agree to ZeroBriks{" "}
                  <span
                    onClick={goToTermsAndConditions}
                    className="font-semibold cursor-pointer hover:underline"
                    style={{ color: MAROON }}
                  >
                    Terms &amp; Conditions
                  </span>{" "}
                  and{" "}
                  <span
                    onClick={goToPrivacyPolicy}
                    className="font-semibold cursor-pointer hover:underline"
                    style={{ color: MAROON }}
                  >
                    Privacy Policy
                  </span>
                </span>
              </label>

              {/* Submit */}
              <button
                onClick={handleSignUp}
                className={`flex items-center justify-center w-full gap-2 py-2 text-xs font-semibold text-white transition rounded-lg ${
                  !agreed ? "bg-gray-400 cursor-not-allowed" : "hover:opacity-90"
                }`}
                style={agreed ? { backgroundColor: MAROON } : undefined}
                disabled={!agreed}
              >
                {isSubmitting ? (
                  "Sending OTP..."
                ) : (
                  <>
                    Create My Account <IoArrowForward size={16} />
                  </>
                )}
              </button>

              <p className="mt-2 text-[11px] text-center text-gray-500">
                Already have an account?{" "}
                <button
                  onClick={() => setShowLoginModal(true)}
                  className="font-semibold hover:underline"
                  style={{ color: MAROON }}
                >
                  Login
                </button>
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SignUp1;